import React from "react";
import Contain from "../components/E";
function Estore() {
    return (
        <Contain/>
    );
}

export default Estore;